import { render } from "./TournamentStatistics.vue?vue&type=template&id=394de8e0&ts=true"
import script from "./TournamentStatistics.vue?vue&type=script&lang=ts"
export * from "./TournamentStatistics.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Admin/Reports/TournamentStatistics.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "394de8e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('394de8e0', __exports__)) {
    api.reload('394de8e0', __exports__)
  }
  
  module.hot.accept("./TournamentStatistics.vue?vue&type=template&id=394de8e0&ts=true", () => {
    api.rerender('394de8e0', render)
  })

}


export default __exports__